





























































import BaseComponent from '@/components/base-component.vue';
import * as serviceParam from '@/services/parameters';
import {
  INDEXACAO_1,
  INDEXACAO_2,
  INDEXACAO_3,
  INDEXACAO_4
} from '@/settings/consts/parameters-keys';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class PrescriptionTemplateParameter extends BaseComponent {
  @Prop()
  public input: any[];
  
  @Prop()
  public item: any;

  public indexacao1: any[] = [];
  public indexacao2: any[] = [];
  public indexacao3: any[] = [];
  public indexacao4: any[] = [];
  public selectIndexacao1: any = null;
  public selectIndexacao2: any = null;
  public selectIndexacao3: any = null;
  public selectIndexacao4: any = null;

  public beforeMount(): void {
    this.loadIndexacoes();
  }

  public onChangeIndexacao() {
    let input = [];
    if (this.selectIndexacao1 && this.selectIndexacao1.id) {
      input.push({... this.selectIndexacao1});
    }
    if (this.selectIndexacao2 && this.selectIndexacao2.id) {
      input.push({... this.selectIndexacao2});
    }
    if (this.selectIndexacao3 && this.selectIndexacao3.id) {
      input.push({... this.selectIndexacao3});
    }
    if (this.selectIndexacao4 && this.selectIndexacao4.id) {
      input.push({... this.selectIndexacao4});
    }
    this.$emit('input', input);
  }

  //PEGAR TIPO PARAMETRO DO ENUM
  @Watch('item')
  public selectedIndexacoes(): void {
    if (!this.item || !this.item.padroesTemplate) {
      return;
    }
    this.selectIndexacao1 = null
    this.selectIndexacao2 = null;
    this.selectIndexacao3 = null;
    this.selectIndexacao4 = null;
    this.item.padroesTemplate.map((item) => {
      if (item.tipoParametro == INDEXACAO_1) {
        let sel = this.indexacao1.find(i => i.value.id == item.id);
        this.selectIndexacao1 = sel ? sel.value : null;
      }
      if (item.tipoParametro == INDEXACAO_2) {
        let sel = this.indexacao2.find(i => i.value.id == item.id);
        this.selectIndexacao2 = sel ? sel.value : null;
      }
      if (item.tipoParametro == INDEXACAO_3) {
        let sel = this.indexacao3.find(i => i.value.id == item.id);
        this.selectIndexacao3 = sel ? sel.value : null;
      }
      if (item.tipoParametro == INDEXACAO_4) {
        let sel = this.indexacao4.find(i => i.value.id == item.id);
        this.selectIndexacao4 = sel ? sel.value : null;
      }
    });
  }
  private loadIndexacoes() {
    serviceParam.getParameters().subscribe((data) => {
      data.map((item) => {
        if (item.tipoParametro == INDEXACAO_1) {
          this.indexacao1 = this.mapIndexacaoItem(item);
        } else if (item.tipoParametro == INDEXACAO_2) {
          this.indexacao2 = this.mapIndexacaoItem(item);
        } else if (item.tipoParametro == INDEXACAO_3) {
          this.indexacao3 = this.mapIndexacaoItem(item);
        } else if (item.tipoParametro == INDEXACAO_4) {
          this.indexacao4 = this.mapIndexacaoItem(item);
        }
      });
    });
  }

  mapIndexacaoItem(item) {
    return item.valores
      .filter((valor) => valor.ativo === true)
      .map((valor) => {
        return {
          titulo: item.nome,
          value: valor,
          label: valor.nome,
        };
      });
  }
}
